import editItem from '../edit-item'
// 表单插槽以及表单校验相关的代码
export default {
  data () {
    return {
      // 记录原始{key: value}的格式
      resetValueData: {},
      // 记录原始{key: text}的格式
      resetTextData: {},
      isInit: false // 等待scopedSolts和resetValueData初始化之后再渲染组件
    }
  },
  components: {
    editItem // 单元组件
  },
  created () {
    this.initCreated()
  },
  mounted () {
    this.initMounted()
  },
  methods: {
    validateForm (callback) { // 校验所有item
      let valid = true
      let msgs = []
      let items = []
      this.formOptions.forEach((item, index) => {
        const itemVm = this.$refs.editItems[index]
        const {flag, msg} = itemVm.validate()
        if (!flag) {
          valid = false
          msgs.push(msg)
          items.push(item)
        }
      })
      callback && callback(valid, msgs, items)
      let obj = { msgs, items } // 作为catch参数传递给外部处理
      return valid ? Promise.resolve() : Promise.reject(obj)
    },
    initResetValueData () { // 初始化需要重置的对象
      this.formOptions.forEach((item, index) => {
        let key = item.key || item.label || item.title || index
        this.resetValueData[key] = item.value
        this.resetTextData[key] = item.text
      })
    },
    reset () {
      this.formOptions.forEach((item, index) => {
        let key = item.key || item.label || item.title || index
        let initValue = this.resetValueData[key]
        let initText = this.resetTextData[key]
        if (typeof initValue !== 'undefined') {
          item.value = initValue
          item.text = initText
          // 重置校验状态
          const itemVm = this.$refs.editItems[index]
          itemVm.errorMsg = null
        }
      })
    },
    init () { // 因为formOptions是需要请求回来，延迟执行，所以提供一个函数重置这些处理函数
      this.isInit = false
      this.$nextTick(() => {
        this.initCreated()
        this.initMounted()
      })
    },
    initCreated () {
      this.formOptions.forEach(item => {
        const slots = this.$slots[item.key]
        if (slots) { // 默认插槽
          item.slots = slots
        }
      })
    },
    initMounted () {
      // this.formOptions.forEach(item => {
      //   // 直接把最外级插槽存进item，便于edit-item组件直接使用
      //   item.scopedSlotsOut = this.$scopedSlots
      // })
      // 时机触发： 初始化需要重置的对象
      this.initResetValueData()
      this.isInit = true
    },
    // 对外提供一个获取{key: item} 的格式
    getObjData (arr) {
      return this.getValueTextCommon('obj', arr)
    },
    // 对外提供一个方法获取当前 {key: value}的格式
    getValueData (arr) {
      return this.getValueTextCommon('value', arr)
    },
    getTextData (arr) { // 对外提供一个方法获取当前 {key: text}的格式
      return this.getValueTextCommon('text', arr)
    },
    getValueTextCommon (type, arr) {
      let valueData = {}
      let formOptions = arr || this.formOptions
      formOptions.forEach((item, index) => {
        let key = item.key || item.label || item.title || index
        valueData[key] = type === 'obj' ? item : item[type]
      })
      return valueData
    }
  }
}
